import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';
import { LANGUAGES } from './languages';

declare const Prism;

@Component({
	selector: 'app-translate',
	templateUrl: './translate.component.html',
	styleUrls: ['./translate.component.scss']
})
export class TranslateComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@Input() emailRegExp: any;
	@ViewChild('translateForm', { static: true }) translateForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	translateFormSubscription: Subscription;
	componentDataSubscription: Subscription;
	isAdmin;
	readonly LANGUAGES = LANGUAGES;

	// howto and config
	snippetHtml: string;
	isConfigShown: Boolean = Boolean(false);
	modalHeight = window.innerHeight * 0.9;
	innerHeight = window.innerHeight * 0.8;
	designedSnippet;
	stringifyConfig;
	isHowtoShown = false;

	isPreviewPromiseCompleted: Boolean = false;
	previewPromiseSubscription: Subscription;

	constructor(private comService: ComponentService, private overlay: OverlayService, private auth: AuthService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();

		this.translateFormSubscription = this.translateForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.translateForm.dirty && this.translateForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.translateForm.dirty && this.translateForm.valid),
				debounceTime(2000)
			)
			.subscribe();

		this.previewPromiseSubscription = this.comService.isPreviewPromiseCompleted.subscribe(
			(res) => (this.isPreviewPromiseCompleted = res)
		);
	}

	ngOnDestroy() {
		this.translateFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	previewTranslation(index) {
		if (this.componentData.config.translation[index].text != '') {
			const languageChoice = this.LANGUAGES.find((item) => item.code == this.componentData.config.translation[index].language);
			if (
				confirm(
					`Are sure you want to preview this translation to ${languageChoice.name}? Any changes you have made to the translation preview will be lost!`
				)
			) {
				this.componentData.config.translation[index].locked = false;
				this.brodcastToPreview();
			}
		} else {
			this.componentData.config.translation[index].locked = false;
			this.brodcastToPreview();
		}
	}

	addTranslation() {
		if (this.componentData.config.translation.length < 10) {
			this.componentData.config.translation.push({
				language: 'fr',
				text: '',
				merge_tag_value: '',
				locked: true
			});
		} else {
			this.overlay.updateOverlay(true, 'You have reached the maximum translation limit of 10!', 'alert');
		}
	}

	removeTranslation(index) {
		this.componentData.config.translation.splice(index, 1);
	}

	singleOnly() {
		this.componentData.config.translation.splice(1);
	}

	showConfig() {
		this.designedSnippet =
			this.componentData && this.componentData.config
				? Prism.highlight(JSON.stringify(this.componentData.config, null, '\t'), Prism.languages.json)
				: Prism.highlight(JSON.stringify({}, null, '\t'), Prism.languages.json);

		this.stringifyConfig =
			this.componentData && this.componentData.config
				? JSON.stringify(this.componentData.config, null, '\t')
				: JSON.stringify({}, null, '\t');
	}

	editConfig() {
		this.componentData.config = JSON.parse(this.stringifyConfig);
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
		this.designedSnippet = Prism.highlight(JSON.stringify(this.componentData.config, null, '\t'), Prism.languages.json);
		this.stringifyConfig = JSON.stringify(this.componentData.config, null, '\t');
	}
}
